import React, {useContext, useState} from "react";
import {
    Box,
    Button,
    Card,
    CardHeader,
    CardBody,
    CardFooter,
    Grid,
    Grommet,
    grommet,
    Header,
    Heading,
    Image,
    Page,
    PageContent,
    PageHeader,
    Paragraph,
    ResponsiveContext,
    Text, Footer, Anchor, Nav,
} from "grommet";
import {deepMerge} from "grommet/utils";
import {ChatOption, CircleInformation, Favorite, Home, Moon, Notification, ShareOption, Shop, Sun, Tag} from "grommet-icons";
import {
    BrowserRouter,
    Routes,
    Route, Router,
} from "react-router-dom";
import Login from './pages/Login';
import QRScanner from "./component/QRScanner";
import NotFound from "./pages/NotFound";
import ForgotPassword from "./pages/ForgotPassword";
import Register from "./pages/Register";
import { getToken, storeToken } from './utils/token';
import CustomerDashboard from "./component/CustomerDashboard";
import {BarcodeScanner} from "./component/QrScan";
import Dashboard from "./pages/Dashboard";
import Shops from "./pages/Shops";
import Info from "./pages/Info";
import Offers from "./pages/Offers";
import ResetPassword from "./pages/ResetPassword";
import Landing from "./pages/Landing";

const theme = deepMerge(grommet, {
    global: {
        colors: {
            brand: '#C01219',
        },
        font: {
            family: "Playfair Display",
            size: "18px",
            height: "20px",
        },
    },
});
function Homepage() {
    return (
        <Grid columns="medium" gap="medium" pad={{bottom: "small"}}>
            <Box pad="small" gap="small" width="medium">
                <Card background="light-1" border="dark">
                    <CardHeader pad="medium">
                        <Text weight={"bold"} color={"brand"}>
                            Personal Info
                        </Text>
                    </CardHeader>
                    <CardBody pad="medium">
                        <Box direction={"row"} pad={"small"} gap={"medium"}>
                            <Text alignSelf={"center"} wordBreak={"break-all"}>
                                Matteo Domenici
                            </Text>
                            <Image
                                fit="cover"
                                src="https://upload.wikimedia.org/wikipedia/commons/thumb/d/d0/QR_code_for_mobile_English_Wikipedia.svg/330px-QR_code_for_mobile_English_Wikipedia.svg.png"
                            />

                        </Box>
                    </CardBody>
                    <CardFooter pad={{horizontal: "small"}} background="light-3">
                        <Button icon={<ShareOption color="plain" />} hoverIndicator />
                    </CardFooter>
                </Card>
            </Box>
{/*
            <Box pad="medium" gap="medium" width="large" direction={"row"}>
                <Card background="white" border="dark">
                    <CardBody pad="small">
                        <Box direction={"column"} pad={"medium"} gap={"small"}>
                            <Image
                                fit="cover"
                                src="https://cdn-icons-png.flaticon.com/512/657/657076.png"
                            />
                            <Text weight={"lighter"} color={"brand"} wordBreak={"keep-all"}>
                                Card Info
                            </Text>
                        </Box>
                    </CardBody>
                </Card>
                <Card background="white" border="dark">
                    <CardBody pad="small">
                        <Box direction={"column"} pad={"medium"} gap={"small"}>
                            <Image
                                fit="contain"
                                src="https://cdn-icons-png.flaticon.com/512/1507/1507683.png"
                            />
                            <Text weight={"lighter"} color={"brand"} wordBreak={"keep-all"}>
                                Scan QR code
                            </Text>
                        </Box>
                    </CardBody>
                </Card>
            </Box>
*/}
        </Grid>
    )
}

function About() {
    return <h2>About</h2>;
}

function Users() {
    return <h2>Users</h2>;
}


const CardTemplate = ({title}) => {
    const size = useContext(ResponsiveContext);
    return (
        <Card>
            <CardHeader pad="medium">
                <Heading level={2} margin="none">
                    {title}
                </Heading>
            </CardHeader>
            <CardBody pad="medium">
                <Paragraph maxLines={size === "small" ? 3 : undefined}>
                    Lorem ipsum dolor sit amet, consectetur adipiscing elit. Maecenas
                    porttitor non nulla ac vehicula. Aliquam erat volutpat. Mauris auctor
                    faucibus est at mattis. Aliquam a enim ac nisi aliquam consectetur et
                    ac velit. Mauris ut imperdiet libero.
                </Paragraph>
            </CardBody>
            <CardFooter pad="medium" background="background-contrast">
                Footer
            </CardFooter>
        </Card>
    );
};

const AppBar = (props) => (

    <Header
        background="brand"
        pad={{left: "medium", right: "small", vertical: "small"}}
        elevation="medium"
        {...props}
    />
);

function App() {
    const [dark, setDark] = useState(false);
    const accessToken = getToken();
    const storeOperatorRole = 1;

    return (
        <BrowserRouter basename="/webapp">
            <Grommet theme={theme} full>
                <Routes>
                    <Route path="/" element={accessToken? <Dashboard /> : <Login />} />
                    <Route path="/register" element={ <Register />} />
                    <Route path="/forgot-password" element={ <ForgotPassword />} />
                    <Route path="/reset-password/:resetCode" element={ <ResetPassword />} />
                    <Route path="/dashboard" element={ accessToken ? <Dashboard /> : <NotFound />} />
                    <Route path="/stores" element={ accessToken ? <Shops /> : <NotFound />} />
                    <Route path="/info" element={ accessToken ? <Info /> : <NotFound />} />
                    <Route path="/offers" element={ accessToken ? <Offers /> : <NotFound />} />
                    <Route path="*" element={<NotFound />} />
                </Routes>
            </Grommet>
        </BrowserRouter>
    );
    /*
    if(!token) {
        return <Login setToken={setToken} />
    }

    return (
        <Grommet theme={theme} full>
            <Page>
                <AppBar>
                    <Text size="medium" color="white" >SAPAS PET</Text>
                    <Button
                        a11yTitle={dark ? "Switch to Light Mode" : "Switch to Dark Mode"}
                        icon={dark ? <Moon/> : <Sun/>}
                        onClick={() => setDark(!dark)}
                        tip={{
                            content: (
                                <Box
                                    pad="small"
                                    round="small"
                                    background={dark ? "dark-1" : "light-3"}
                                >
                                    {dark ? "Switch to Light Mode" : "Switch to Dark Mode"}
                                </Box>
                            ),
                            plain: true,
                        }}
                    />
                </AppBar>
                <PageContent>
                    <PageHeader size="small" title="Benvenuto!"/>
                        <BrowserRouter>
                            <Routes>
                                <Route path="/about" element={<About/>}/>
                                <Route path="/qr-scanner" element={<QRScanner/>}/>
                                <Route path="/" element={<Homepage/>}/>
                            </Routes>

                        </BrowserRouter>
                </PageContent>
                <Footer background="brand" pad="small" align={"end"} direction={"row-reverse"}>
                    <Text weight={"bold"} color={"white"}>20PT</Text>
                </Footer>
                <Footer align="center" justify="center" gap="xsmall" pad={"small"}>
                    <Nav direction="row" background="white" pad="xsmall" gap={"xlarge"}>
                        <Anchor href="/" icon={<Home/>} hoverIndicator/>
                        <Anchor href="/about" icon={<Tag/>} hoverIndicator/>
                        <Anchor href="/qr-scanner" icon={<Shop/>} hoverIndicator/>
                        <Anchor href="/users" icon={<CircleInformation/>} hoverIndicator/>
                    </Nav>
                </Footer>
            </Page>
        </Grommet>
    );*/
}

export default App;
